import React, { useEffect } from 'react';
import '../../../App.css';
import './Sculc2025.css';
import { useAuth } from '../../../contexts/AuthContext.js';
import { useNavigate } from 'react-router-dom';
import { getFirestoreData } from '../../../firebase/Firestore.js';

import AOS from 'aos';
import 'aos/dist/aos.css';

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import SculcNavbar from '../SculcNavbar.js';

const Sculc2025 = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);


    const slides = [
  {
    presenter: (
     <>
        <strong>Keynote: </strong> Dr. Shri Narayanan
      </>
      ),
    link: "https://drive.google.com/file/d/1oRo3VNlv2py9czxBB-Z-Cmt0ghX8vXaS/preview"
  },
  {
    presenter: "Manxin Lan - Nuosu Yi...",
    link: "https://drive.google.com/file/d/1a431DDqQzR8YvpqBfY0jCRtSEQlx0pp_/preview"
  },
  {
    presenter: "Geneva Flores - Names and Social Meaning ",
    link: "https://drive.google.com/file/d/1W2GJ0QGngaJA46MhjkD8jnVBzvPncbYbxSNmu3e9YxU/preview"
  },

  {
    presenter: "Ziang Wang-  Syntactic Distribution...in Mandarin Chinese",
    link: "https://docs.google.com/presentation/d/1POewfdBY3droVsFmMrcYnz9hc08dsrzQBPq8cJ3x0XU/preview"
  },


];

  
    return (
        <>
        <div className="sculc2025-page">
            <div className="sculc2025-header-container">
                <img
                    src="/images/sculc-banner.jpg"
                    alt="Header"
                    className="sculc2025-header-image"
                />  
                <h1 className="sculc2025-title">SCULC 2025</h1>
            </div>

                <div className="sculc2025-banner">
                    <p style={{ fontSize: "1.5em" }}>SCULC 2025 has concluded!</p>
                    <br />
                    <a href="/sculc-2026" className="sculc2026-link">Check out SCULC 2026</a>
                </div>

                <div className="sculc2025-container">
                    <div className="sculc2025-table-container">
                        <div className="sculc2025-logo-container">
                            <img src="/images/sculc-logo.png" alt="Sculc-logo" className="sculc2025-logos" />
                            <img src="/images/dept-ling.png" alt="dept-of-ling" className="sculc2025-logos" />
                            <img src="/images/bruin-linguists-logo.png" alt="club-logo" className="sculc2025-logos" />
                        </div>
                        <div className="sculc2025-table-cells">
                            <h2 className="sculc2025-subtitle" >Southern California Undergraduate Linguistics Conference</h2>
                            <br />
                            <p style={{ fontSize: "1.3em" }}>Saturday, 18 May 2025, 09:00 AM - 05:00 PM</p>
                            <br />
                            <p style={{ fontSize: "1.3em" }}>UCLA's Campbell Hall Learning Pavilion</p>
                            <br />
                            <p style={{ fontSize: "1.2em", textAlign: "left", lineHeight: "1.5em" }}>
                                <strong>SCULC</strong> (the Southern California Undergraduate Linguistics Conference) will be held again in May 2025 by the UCLA Linguistics Department and the undergraduate-run Bruin Linguists Society.
                                It’s a student-run, collaborative, and educational environment to showcase undergraduate research from across institutions.
                            </p>
                            <br />
                            <p><i>Sponsored by the UCLA Department of Linguistics and the Bruin Linguists Society</i></p>
                            <div style={{ height: "5em" }}></div>
                        </div>
                    </div>

                    {/* Key note Speaker */}
                    <div id="keynote-speaker" className="keynote-speaker">
                        <h2 className="keynote-title">KEYNOTE SPEAKER</h2>
                        <div className="keynote-content">
                            <img 
                                src="/images/ShriNarayanan-2025-UCLA.jpg" 
                                alt="Keynote Speaker" 
                                className="keynote-image"
                                width="160" height="220"
                            />
                            <div className="keynote-details">
                                <h3 className="keynote-name">Dr. Shrikanth Narayanan </h3>
                                <p className="keynote-affiliation"> University of Southern California, Los Angeles, CA </p>
                                <p className="keynote-description">
                                    Dr. Shrikanth Narayanan is a professor at USC and a leading expert in speech science; bridging linguistics, psychology, and machine intelligence. 
                                    In his keynote, he will explore how modeling the human vocal instrument and speech-based AI advances clinical applications and technology. 
                                    He will also discuss the challenge of creating inclusive, trustworthy speech technologies.
                                </p>
                                <p className="keynote-abstract">
                                    <a 
                                        href="https://docs.google.com/document/d/1K5Q8t9fnjdiwZXMxeF_WEr2mW9lxzkMG/edit?usp=sharing&ouid=104781865078171920700&rtpof=true&sd=true" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="keynote-abstract-link"
                                    >
                                        Read the Keynote Abstract
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div id="conference-info" className="conference-info">
                        <h2 className="subtitle">PROGRAM</h2>
                        <p className="normal-text">
                            Please see below for the official 2025 conference program.
                        </p>
                        <iframe
                        src="/sculc-program.pdf"
                        title="SCULC Program"
                        width="100%"
                        height="600px"
                        style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                        ></iframe>

                    </div>
                    <div id="presentations" className="presentations">
                        <h2 className="subtitle">PRESENTATIONS</h2>
                        <p className="normal-text">
                            See below for presentation slides and posters by SCULC 2025 presenters.
                        </p>

                        {slides.map((slide, index) => (
                            <details key={index} className="slide-details">
                            <summary>{slide.presenter}</summary>
                            <div className="slide-embed">
                                <iframe
                                src={slide.link}
                                allowFullScreen
                                title={`Slides by ${slide.presenter}`}
                                ></iframe>
                            </div>
                            </details>
                        ))}
                    </div>

                </div>
            </div>
        </>

        
    );
};

export default Sculc2025;